webpackJsonp([1],{

/***/ "/shd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cd8P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GJh2":
/***/ (function(module, exports, __webpack_require__) {

var Matter = __webpack_require__("ot4M");

// const _isBrowser = typeof window !== 'undefined' && window.location
// const Matter = _isBrowser ? window.Matter : require('../../build/matter-dev.js')

var Scene = {};
Matter.Scene = Scene;
var Engine = Matter.Engine;

Scene.engine = function () {
  // Scene.engine = function (demo) {
  // some example engine options
  var options = {
    positionIterations: 6,
    velocityIterations: 4,
    enableSleeping: false,
    metrics: { extended: true }
  };
  return Engine.create(options);
};

// add scenes
Scene.gravity = __webpack_require__("KUA7");

module.exports = Scene;

/***/ }),

/***/ "GVay":
/***/ (function(module, exports, __webpack_require__) {

var Matter = __webpack_require__("ot4M");
var Scenes = __webpack_require__("GJh2");

var Game = {};

// const isBrowser = typeof window !== 'undefined' && window.location
// const isMobile = isBrowser && /(ipad|iphone|ipod|android)/gi.test(navigator.userAgent)

Matter.Game = Game;

// Matter aliases
var Body = Matter.Body;
var Engine = Matter.Engine;
var World = Matter.World;
var Common = Matter.Common;
var Bodies = Matter.Bodies;
var Events = Matter.Events;
var MouseConstraint = Matter.MouseConstraint;
var Render = Matter.Render;

Game.create = function (options) {
  var defaults = {
    isManual: false,
    // sceneName: 'gravity', // default
    sceneEvents: []
  };
  return Common.extend(defaults, options);
};

Game.init = function (containerEl) {
  var game = Game.create();
  Matter.Game._game = game;
  // get container element for the canvas
  game.container = containerEl; // document.getElementById('matterjs')
  // create an example engine (see /examples/engine.js)
  game.engine = Scenes.engine();
  // run the engine
  game.runner = Engine.run(game.engine);
  // create a debug renderer
  game.render = Render.create({
    element: game.container,
    engine: game.engine,
    options: {
      width: game.container.offsetWidth,
      height: game.container.offsetHeight
    }
  });
  // run the renderer
  Render.run(game.render);
  // add a mouse controlled constraint
  game.mouseConstraint = MouseConstraint.create(game.engine, {
    element: game.render.canvas,
    constraint: {
      render: {
        visible: false
      }
    }
  });
  World.add(game.engine.world, game.mouseConstraint);
  // pass mouse to renderer to enable showMousePosition
  game.render.mouse = game.mouseConstraint.mouse;
  // set up a scene with bodies
  Game.reset(game);
  Game.setScene(game, game.container.dataset.game);
  // pass through runner as timing for debug rendering
  game.engine.metrics.timing = game.runner;

  return game;
};

Game.setScene = function (game, sceneName) {
  var options = {
    shapesFill: game.container.dataset.fill
  };
  Scenes[sceneName](game, options);
};

Game.reset = function (game) {
  var world = game.engine.world;
  var i = void 0;

  // DESTORY OLD WORLD ====================================

  World.clear(world);
  Engine.clear(game.engine);

  // clear scene graph (if defined in controller)
  if (game.render) {
    var renderController = game.render.controller;
    if (renderController && renderController.clear) {
      renderController.clear(game.render);
    }
  }
  // clear all scene events
  if (game.engine.events) {
    for (i = 0; i < game.sceneEvents.length; i += 1) {
      Events.off(game.engine, game.sceneEvents[i]);
    }
  }
  if (game.mouseConstraint && game.mouseConstraint.events) {
    for (i = 0; i < game.sceneEvents.length; i += 1) {
      Events.off(game.mouseConstraint, game.sceneEvents[i]);
    }
  }
  if (world.events) {
    for (i = 0; i < game.sceneEvents.length; i += 1) {
      Events.off(world, game.sceneEvents[i]);
    }
  }
  if (game.runner && game.runner.events) {
    for (i = 0; i < game.sceneEvents.length; i += 1) {
      Events.off(game.runner, game.sceneEvents[i]);
    }
  }
  if (game.render && game.render.events) {
    for (i = 0; i < game.sceneEvents.length; i += 1) {
      Events.off(game.render, game.sceneEvents[i]);
    }
  }

  game.sceneEvents = [];

  // reset id pool
  Body._nextCollidingGroupId = 1;
  Body._nextNonCollidingGroupId = -1;
  Body._nextCategory = 0x0001;
  Common._nextId = 0;

  // reset random seed
  Common._seed = 0;

  // BUILD NEW WORLD ====================================

  game.engine.enableSleeping = false;
  game.engine.world.gravity.y = -0.25;
  game.engine.world.gravity.x = 0;
  game.engine.timing.timeScale = 1;

  // world boundaries
  var offset = -5; // 150
  var thickness = 50;
  var frame = {
    width: game.render.options.width,
    height: game.render.options.height
  };
  var options = {
    restitution: 0.25,
    isStatic: true,
    render: {
      fillStyle: 'green',
      strokeStyle: 'transparent'
    }
  };
  var top = Bodies.rectangle(frame.width / 2, // x
  0 - thickness / 2 - offset, // y
  frame.width + thickness * 2 + offset * 2, // + (thickness * 2), // width
  thickness, options);
  var bottom = Bodies.rectangle(frame.width / 2, // x
  frame.height + thickness / 2 + offset, // y
  frame.width + thickness * 2 + offset * 2, // width
  thickness, // height
  options);
  var left = Bodies.rectangle(0 - thickness / 2 - offset, // x
  frame.height / 2, // y
  thickness, // width
  frame.height + thickness * 2 + offset * 2, // height
  options);
  var right = Bodies.rectangle(frame.width + offset + thickness / 2, // x
  frame.height / 2, // y
  thickness, // width
  frame.height + thickness * 2 + offset * 2, // height
  options);
  // add boundaries
  World.add(world, [top, bottom, left, right]);

  // add Mouse Constraint
  if (game.mouseConstraint) {
    World.add(world, game.mouseConstraint);
  }

  // render it
  if (game.render) {
    var renderOptions = game.render.options;
    renderOptions.wireframes = false;
    renderOptions.hasBounds = false;
    renderOptions.showDebug = false;
    renderOptions.showBroadphase = false;
    renderOptions.showBounds = false;
    renderOptions.showVelocity = false;
    renderOptions.showCollisions = false;
    renderOptions.showAxes = false;
    renderOptions.showPositions = false;
    renderOptions.showAngleIndicator = false;
    renderOptions.showIds = false;
    renderOptions.showShadows = false;
    renderOptions.showVertexNumbers = false;
    renderOptions.showConvexHulls = false;
    renderOptions.showInternalEdges = false;
    renderOptions.showSeparations = false;
    renderOptions.background = 'transparent';
  }
};

Game.changeGame = function (sceneName) {
  var game = Matter.Game._game;
  Game.reset(game);
  Game.setScene(game, sceneName);
};

Game.explosion = function () {
  var engine = Matter.Game._game.engine;
  var bodies = Matter.Composite.allBodies(engine.world);

  engine.world.gravity.y = 0;

  for (var i = 0; i < bodies.length; i += 1) {
    var body = bodies[i];
    if (!body.isStatic) {
      var forceMagnitude = 0.03 * body.mass;
      Body.applyForce(body, body.position, {
        x: (forceMagnitude + Common.random() * forceMagnitude) * Common.choose([1, -1]),
        y: (forceMagnitude + Common.random() * -forceMagnitude) * Common.choose([1, -1])
      });
    }
  }
};

Game.gravity = function () {
  var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var g = Matter.Game._game.engine.world.gravity;
  g.x = x;
  g.y = y;
};

module.exports = Game;

/***/ }),

/***/ "KUA7":
/***/ (function(module, exports, __webpack_require__) {

var Matter = __webpack_require__("6wRV");
// const tinycolor = require('tinycolor2')

// gravity
var World = Matter.World;
var Bodies = Matter.Bodies;
var Composites = Matter.Composites;
var Events = Matter.Events;
var Common = Matter.Common;
var defaultSettings = {
  shapesFill: 'rgb(255,0,98)'
};

var ballPit = function ballPit(game) {
  var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultSettings;

  var engine = game.engine;
  var world = engine.world;
  var mouseConstraint = game.mouseConstraint;
  var sceneEvents = game.sceneEvents;
  var dragged = false;

  // Events
  sceneEvents.push(
  // an example of using mouse events on a mouse
  Events.on(mouseConstraint, 'startdrag', function () {
    if (game.container.classList.contains('behind-text')) {
      game.container.classList.add('behind-text');
    }
    dragged = true;
  }));
  sceneEvents.push(
  // an example of using mouse events on a mouse
  Events.on(mouseConstraint, 'mousedown', function () {
    if (dragged) {
      dragged = false;
      game.container.classList.remove('behind-text');
    }
  }));

  // Bodies
  var w = game.render.options.width;
  var h = game.render.options.height;
  var stack = Composites.stack(w / 4, h / 4, 4, 4, 50, 100, function (x, y) {
    var options = {
      // frictionAir: 0,
      // friction: 0.001, //0.0001,
      restitution: 0.4,
      render: {
        fillStyle: settings.shapesFill,
        strokeStyle: 'transparent'
      }
    };
    switch (Math.round(Common.random(0, 1))) {
      case 0:
        return Bodies.polygon(x, y, Math.round(Common.random(1, 1)), Common.random(75, 75), options);
      case 1:
        if (Common.random() < 0.8) {
          return Bodies.rectangle(x, y, Common.random(100, 150), Common.random(100, 150), options);
        }
        return Bodies.rectangle(x, y, Common.random(150, 200), Common.random(50, 60), options);
      default:
    }
    return true; // eslint wants a return, but does this break anythign?
  });

  World.add(world, stack);
};

module.exports = ballPit;

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./src/demo/DemoContent.js
var DemoContent = __webpack_require__("utQL");
var DemoContent_default = /*#__PURE__*/__webpack_require__.n(DemoContent);

// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var throttle = __webpack_require__("+X65");
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);

// EXTERNAL MODULE: ./node_modules/tinycolor2/tinycolor.js
var tinycolor = __webpack_require__("YrBu");
var tinycolor_default = /*#__PURE__*/__webpack_require__.n(tinycolor);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/player/Background.vue
//
//
//
//
//

/* harmony default export */ var Background = ({
  props: ['main', 'mainTransition', 'gradient'],
  computed: {
    layer0: function layer0() {
      return {
        backgroundColor: this.main,
        transitionDuration: this.mainTransition + 'ms'
      };
    },
    layer1: function layer1() {
      return {
        opacity: this.gradient.opacity,
        background: 'linear-gradient(to ' + this.gradient.direction + ', ' + this.gradient.start + ' 0%, ' + this.gradient.end + ' 100%)'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-136179a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/player/Background.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background",style:(_vm.layer0)},[_c('div',{staticClass:"background",style:(_vm.layer1)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var player_Background = (esExports);
// CONCATENATED MODULE: ./src/components/player/Background.vue
function injectStyle (ssrContext) {
  __webpack_require__("/shd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-136179a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Background,
  player_Background,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_player_Background = (Component.exports);

// EXTERNAL MODULE: ./src/plugins/game.js
var game = __webpack_require__("GVay");
var game_default = /*#__PURE__*/__webpack_require__.n(game);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/player/Game.vue
//
//
//
//


/* harmony default export */ var Game = ({
  props: ['current', 'play', 'gaming', 'event'],
  data: function data() {
    return {
      isBackground: false
    };
  },

  watch: {
    current: function current(_current) {
      this.$nextTick(function () {
        game_default.a.changeGame(_current.game);
      });
    },
    gaming: function gaming(_gaming) {
      var _this = this;

      if (_gaming) this.$nextTick(function () {
        _this.start();
      });
    },
    play: function play(_play) {
      if (_play) {
        game_default.a.explosion();
        game_default.a.gravity(0, 0);
      } else {
        game_default.a.gravity(0, 0.25);
      }
    },
    event: function event() {
      game_default.a.explosion();
    }
  },
  methods: {
    start: function start() {
      game_default.a.init(this.$el);
    },

    isBehindText: function isBehindText() {
      this.$el.classList.add('behind-text');
    }
  },
  mounted: function mounted() {
    this.start();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-700b98f9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/player/Game.vue
var Game_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.gaming)?_c('div',{attrs:{"id":"matterjs","data-game":_vm.current.game,"data-fill":_vm.current.colors.shapes},on:{"mousewheel":_vm.isBehindText}}):_vm._e()}
var Game_staticRenderFns = []
var Game_esExports = { render: Game_render, staticRenderFns: Game_staticRenderFns }
/* harmony default export */ var player_Game = (Game_esExports);
// CONCATENATED MODULE: ./src/components/player/Game.vue
function Game_injectStyle (ssrContext) {
  __webpack_require__("eR1o")
}
var Game_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Game___vue_template_functional__ = false
/* styles */
var Game___vue_styles__ = Game_injectStyle
/* scopeId */
var Game___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Game___vue_module_identifier__ = null
var Game_Component = Game_normalizeComponent(
  Game,
  player_Game,
  Game___vue_template_functional__,
  Game___vue_styles__,
  Game___vue_scopeId__,
  Game___vue_module_identifier__
)

/* harmony default export */ var components_player_Game = (Game_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Player.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Game from '@/plugins/game.js'




/* harmony default export */ var Player = ({
  props: ['scenes'],
  components: {
    Background: components_player_Background,
    Gameboard: components_player_Game
  },
  data: function data() {
    return {
      play: false,
      mute: false,
      gaming: true,
      loading: false,
      activeBtnKey: 'logo',
      sceneIndex: 0,
      eventIndex: 0,
      navTop: false,
      bgColor: null
    };
  },

  computed: {
    scene: function scene() {
      return this.scenes[this.sceneIndex];
    },
    event: function event() {
      if (this.scene.events) return this.scene.events[this.eventIndex];
    },
    buttons: function buttons() {
      return {
        logo: '_pwrTalk',
        play: this.play ? 'pause' : 'play',
        mute: this.mute ? 'unmute' : 'mute',
        gaming: this.gaming ? 'clean' : 'messy',
        next: 'next'
      };
    },
    bgColorTransition: function bgColorTransition() {
      return this.event.transition;
    }
  },
  watch: {
    mute: function mute(val) {
      this.$refs.song.muted = val;
    },
    scene: function scene(_scene) {
      this.eventIndex = 0;
      this.bgColor = _scene.colors.bg.color;
    },
    eventIndex: function eventIndex(index) {
      if (index > 0) this.bgColor = tinycolor_default()(this.bgColor)[this.event.action](this.event.value).toString();
    }
  },
  methods: {
    pwrPlay: function pwrPlay(label) {
      var audio = this.$refs.song;
      if (!audio.paused && audio.duration > 0) {
        audio.pause();
        this.play = false;
      } else {
        audio.play();
        this.mute = false;
      }
    },
    audioCanPlay: function audioCanPlay() {
      return this.play ? this.$refs.song.play() : null;
    },

    setEventIndex: throttle_default()(function (e) {
      var currentTime = e.target.currentTime;
      var events = this.scene.events;
      for (var i = events.length - 1; i >= 0; i--) {
        if (currentTime >= events[i].time) {
          this.eventIndex = i;
          break;
        }
      }
    }, 100),
    nextScene: function nextScene() {
      var _this = this;

      this.loading = true;
      // after loading state finishes
      setTimeout(function () {
        _this.sceneIndex = _this.sceneIndex + 1 === _this.scenes.length ? 0 : _this.sceneIndex + 1;
        _this.navTop = !_this.navTop;
        _this.activeBtn = null;
        _this.loading = false;
      }, 550); // have some buffer from animation
    },
    gameState: function gameState() {
      this.gaming = !this.gaming;
    },
    onKeyDown: function onKeyDown(e) {
      // spacebar
      if (e.keyCode === 32) {
        e.preventDefault();
        this.pwrPlay();
      }
    }
  },
  created: function created() {
    if (this.scene) this.bgColor = this.scene.colors.bg.color;
    document.addEventListener('keydown', this.onKeyDown);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keydown', this.onKeyDown);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7429127f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Player.vue
var Player_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'loading' : _vm.loading, 'nav-top' : _vm.navTop},attrs:{"id":"player"}},[_c('nav',{on:{"mouseleave":function($event){_vm.activeBtnKey = null}}},[_c('ul',[_c('li',{style:({ backgroundColor : _vm.scene.colors.btnsOdd }),attrs:{"aria-label":_vm.buttons.play},on:{"click":_vm.pwrPlay,"mouseenter":function($event){_vm.activeBtnKey = 'play'}}}),_c('li',{style:({ backgroundColor : _vm.scene.colors.btnsEven }),attrs:{"aria-label":_vm.buttons.mute},on:{"click":function($event){_vm.mute = !_vm.mute},"mouseenter":function($event){_vm.activeBtnKey = 'mute'}}}),_c('li',{style:({ backgroundColor : _vm.scene.colors.btnsOdd }),attrs:{"aria-label":_vm.buttons.gaming},on:{"click":_vm.gameState,"mouseenter":function($event){_vm.activeBtnKey = 'gaming'}}}),_c('li',{style:({ backgroundColor : _vm.scene.colors.btnsEven }),attrs:{"aria-label":_vm.buttons.next},on:{"click":_vm.nextScene,"mouseenter":function($event){_vm.activeBtnKey = 'next'}}})]),_c('label',{style:({ color: _vm.scene.colors.btnsOdd })},_vm._l((_vm.buttons),function(value,key){return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeBtnKey === key),expression:"activeBtnKey === key"}]},[_vm._v(_vm._s(value))])}))]),_c('article',[_c('div',{staticClass:"text",style:(_vm.scene.textStyle),domProps:{"innerHTML":_vm._s(_vm.scene.text)}}),_c('audio',{ref:"song",attrs:{"src":_vm.scene.song},on:{"canplay":_vm.audioCanPlay,"playing":function($event){_vm.play = true},"timeupdate":_vm.setEventIndex,"ended":_vm.nextScene}})]),_c('background',{attrs:{"main":_vm.bgColor,"mainTransition":_vm.bgColorTransition,"gradient":_vm.scene.colors.gradient}}),_c('gameboard',{attrs:{"play":_vm.play,"gaming":_vm.gaming,"current":_vm.scene,"event":_vm.eventIndex}})],1)}
var Player_staticRenderFns = []
var Player_esExports = { render: Player_render, staticRenderFns: Player_staticRenderFns }
/* harmony default export */ var components_Player = (Player_esExports);
// CONCATENATED MODULE: ./src/components/Player.vue
function Player_injectStyle (ssrContext) {
  __webpack_require__("Cd8P")
}
var Player_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Player___vue_template_functional__ = false
/* styles */
var Player___vue_styles__ = Player_injectStyle
/* scopeId */
var Player___vue_scopeId__ = "data-v-7429127f"
/* moduleIdentifier (server only) */
var Player___vue_module_identifier__ = null
var Player_Component = Player_normalizeComponent(
  Player,
  components_Player,
  Player___vue_template_functional__,
  Player___vue_styles__,
  Player___vue_scopeId__,
  Player___vue_module_identifier__
)

/* harmony default export */ var src_components_Player = (Player_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//




/* harmony default export */ var App = ({
  name: 'App',
  components: {
    Player: src_components_Player
  },
  data: function data() {
    return {
      scenes: DemoContent_default.a.scenes
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea97ccb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{attrs:{"scenes":_vm.scenes}})],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("Twfh")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/router/index.js




vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_Player
  }]
}));
// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "Twfh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eR1o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "utQL":
/***/ (function(module, exports) {

var DemoContent = {
  scenes: [{
    song: '/static/demo/song1.mp3',
    game: 'gravity',
    text: 'pwrTalk is a consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    textStyle: {
      margin: '50vh 0 30vh 25%',
      textAlign: 'center',
      color: 'rgb(113,187,161)'
    },
    colors: {
      btnsOdd: 'rgb(247, 221, 212)',
      btnsEven: 'rgb(255,17,73)',
      bg: {
        color: 'rgb(252,67,111)',
        transition: '750ms'
      },
      gradient: {
        start: 'rgb(252,67,111)',
        end: 'rgb(113,187,161)',
        opacity: 0,
        direction: 'right'
      },
      shapes: 'rgba(255,0,98,.75)'
    },
    events: [{ time: 1, transition: 1200, action: 'spin', value: 20 }, { time: 3, transition: 300, action: 'spin', value: 180 }, { time: 6, transition: 1200, action: 'spin', value: 90 }, { time: 11, transition: 1200, action: 'spin', value: -248 }, { time: 13, transition: 300, action: 'spin', value: -80 }, { time: 16, transition: 1200, action: 'spin', value: 34 }, { time: 21, transition: 1200, action: 'spin', value: 317 }, { time: 23, transition: 300, action: 'spin', value: -68 }, { time: 26, transition: 1200, action: 'spin', value: -128 }]
  }, {
    song: '/static/demo/song2.mp3',
    game: 'gravity',
    text: 'different text',
    textStyle: {
      margin: '75vh 0 50vh 5%',
      textAlign: 'left',
      color: 'rgb(128,133,150)'
    },
    colors: {
      btnsOdd: '#BBD5ED',
      btnsEven: '#CCFFCB',
      bg: {
        color: '#CEFDFF',
        transition: '500ms'
      },
      gradient: {
        start: '#BBD5ED',
        end: 'transparent',
        opacity: 0.5,
        direction: 'right'
      },
      shapes: '#5BD8BD'
    },
    events: [{ time: 6, transition: '1200ms', action: 'spin', value: 40 }, { time: 9, transition: '300ms', action: 'spin', value: -20 }, { time: 15, transition: '1200ms', action: 'spin', value: -60 }]
  }]
};

module.exports = DemoContent;

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.3456b382d7e9fbe5cf05.js